enum Status {
  DEFAULT = 'default',
  LOADING = 'loading',
  SUCCESS = 'success',
  FAILURE = 'failure',
}

export default Status;
